var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1782",
    "data-name": "Groupe 1782",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.205,
    height: 64.204,
    viewBox: "0 0 64.205 64.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1781",
    "data-name": "Groupe 1781",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 32.102,
    cy: 32.102,
    rx: 32.102,
    ry: 32.102,
    transform: "translate(0 0)",
    fill: "#e30613"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mic_FILL0_wght400_GRAD0_opsz48",
    d: "M25.937,30.012a5.384,5.384,0,0,1-4.1-1.764,6.023,6.023,0,0,1-1.651-4.269V9.692a5.449,5.449,0,0,1,1.679-4.041,5.842,5.842,0,0,1,8.139,0,5.449,5.449,0,0,1,1.679,4.041V23.978a6.023,6.023,0,0,1-1.651,4.269,5.384,5.384,0,0,1-4.1,1.764ZM25.937,17.034ZM24.23,47.258V39.517A15.537,15.537,0,0,1,14.1,34.451,14.931,14.931,0,0,1,10,23.978h3.415a11.6,11.6,0,0,0,3.671,8.708,12.312,12.312,0,0,0,8.851,3.529,12.312,12.312,0,0,0,8.851-3.529,11.6,11.6,0,0,0,3.671-8.708h3.415a14.931,14.931,0,0,1-4.1,10.473,15.537,15.537,0,0,1-10.132,5.066v7.741ZM25.937,26.6a2.106,2.106,0,0,0,1.679-.768,2.758,2.758,0,0,0,.655-1.85V9.692a2.156,2.156,0,0,0-.683-1.622,2.409,2.409,0,0,0-3.3,0A2.156,2.156,0,0,0,23.6,9.692V23.978a2.758,2.758,0,0,0,.655,1.85A2.106,2.106,0,0,0,25.937,26.6Z",
    transform: "translate(5.717 6.473)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.ab92f140bbbd72434398b748fc6cdc50.svg";
export { ForwardRef as ReactComponent };